/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Jira({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 75 75" {...props}><path fill="#1868DB" d="M0 18.75C0 8.395 8.395 0 18.75 0h37.5C66.605 0 75 8.395 75 18.75v37.5C75 66.605 66.605 75 56.25 75h-37.5C8.395 75 0 66.605 0 56.25z" /><path fill="#fff" d="M28.043 48.51h-4.226c-6.373 0-10.946-3.903-10.946-9.62h22.723c1.178 0 1.94.837 1.94 2.022v22.866c-5.68 0-9.49-4.601-9.49-11.015zm11.223-11.362H35.04c-6.373 0-10.946-3.835-10.946-9.551h22.723c1.178 0 2.01.767 2.01 1.952v22.866c-5.681 0-9.56-4.601-9.56-11.015zm11.292-11.294h-4.226c-6.373 0-10.946-3.904-10.946-9.62H58.11c1.177 0 1.94.836 1.94 1.952V41.05c-5.681 0-9.492-4.6-9.492-11.014z" /></svg>;
}
;